import { useT } from '@/lib/i18n';

export function LangSwitcher() {
  const { locale, setLocale, t } = useT();

  const toggleLanguage = () => {
    setLocale(locale === 'en' ? 'fr' : 'en');
  };

  return (
    <button
      type="button"
      title={t('header.lang')}
      className="inline-flex h-auto items-center justify-center gap-2 whitespace-nowrap rounded-full border border-border/50 bg-card/50 px-3 py-1 text-xs font-medium text-ink-600 ring-offset-background transition-colors focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 hover:bg-card hover:text-brand-purple dark:text-muted-foreground"
      onClick={toggleLanguage}
    >
      {locale === 'en' ? 'FR' : 'EN'}
    </button>
  );
}
